import cn from 'classnames'
import { FC, useEffect, useRef } from 'react'

import { Input } from 'core-components/library/inputs'
import { PopPaper } from 'core-components/library/popup'

import { useHandleBlur } from '../../hooks/useHandleBlur'
import styles from '../../TreeSelect.module.scss'
import { EmptyListPlaceholder } from '../emptyListPlaceholder/EmptyListPlaceholder'
import { ListOfItems } from '../listOfItems/ListOfItems'
import { OptionsButton } from '../optionsButton/OptionsButton'

import { IPopupContentProps } from './models/popupContentProps'

export const PopupContent: FC<IPopupContentProps> = ({
  listRef,
  isOpened,
  showOnlySelected,
  setShowOnlySelected,
  searchValue,
  setSearchValue,
  treeData,
  selectedValues,
  handleItemClick,
  onBlur,
}) => {
  /** -------------------- Variables ----------------------- */
  const popupRef = useRef<HTMLDivElement>(null)

  /** -------------------- Hooks ----------------------- */
  const { handleBlur, handleMouseOver, handleMouseLeave } = useHandleBlur({ cb: onBlur })

  /** -------------------- Effects ----------------------- */
  useEffect(() => {
    setTimeout(() => {
      if (isOpened && popupRef.current) {
        popupRef.current.focus()
      }
    }, 10)
  }, [isOpened, popupRef])

  return (
    <PopPaper
      className={cn(styles.optionsContainer, {
        [styles.isCollapsed]: isOpened,
      })}
    >
      <div
        tabIndex={1}
        ref={popupRef}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        onBlur={handleBlur}
      >
        <div className={styles.searchContainer}>
          <Input
            classes={{
              root: styles.searchInput,
            }}
            value={searchValue}
            onChange={setSearchValue}
            label="Search"
          />
          <OptionsButton
            listRef={listRef}
            showOnlySelected={showOnlySelected}
            onShowOnlySelectedChange={setShowOnlySelected}
          />
        </div>
        {!treeData.length && <EmptyListPlaceholder />}
        <ListOfItems
          ref={listRef}
          items={treeData}
          selectedItems={selectedValues}
          className={styles.optionsList}
          onItemSelect={handleItemClick}
        />
      </div>
    </PopPaper>
  )
}
